"use client";

import React, { useEffect, useRef } from 'react';
function AdsBlock() {
  const adRef = useRef(null);
  useEffect(() => {
    if (typeof window !== 'undefined' && window.adsbygoogle) {
      try {
        if (window.adsbygoogle.length === 0) {
          (window.adsbygoogle = window.adsbygoogle || []).push({});
        }
      } catch (e) {
        console.error('Adsbygoogle push error:', e);
      }
    }
  }, []);
  return <ins className="adsbygoogle" style={{
    display: 'block',
    width: '100%',
    height: 'auto'
  }} ref={adRef} data-ad-client={process.env.NEXT_PUBLIC_AD_CLIENT} data-ad-slot={process.env.NEXT_PUBLIC_ADD_SLOT} data-ad-format="auto" data-full-width-responsive="true" data-sentry-component="AdsBlock" data-sentry-source-file="AdsBlock.tsx"></ins>;
}
export default AdsBlock;